<template>
  <p class="flex items-center gap-2 text-[14px] font-bold uppercase text-orange">
    <span class="flex size-4 items-center justify-center rounded-full bg-orange/20" aria-hidden="true">
      <span class="size-2 rounded-full bg-orange" />
    </span>
    <slot>Eerste hulp bij einde salderen</slot>
  </p>
</template>

<!--
  The label is a slot with the tool's own name as default: both places that show the chip say the
  same word, so it lives here once, and a different label needs no change to this component.
-->
